import { render, staticRenderFns } from "./ApuracaoDpmGruposCulturaPainel.vue?vue&type=template&id=452fdffe&scoped=true&"
import script from "./ApuracaoDpmGruposCulturaPainel.vue?vue&type=script&lang=js&"
export * from "./ApuracaoDpmGruposCulturaPainel.vue?vue&type=script&lang=js&"
import style0 from "./ApuracaoDpmGruposCulturaPainel.vue?vue&type=style&index=0&id=452fdffe&scoped=true&lang=css&"
import style1 from "./ApuracaoDpmGruposCulturaPainel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452fdffe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VDataTable,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader})
